import React from "react";
import SignupWidgetMain from "../widget/SignupWidget/SignupWidgetMain";
import { Box } from "@mui/material";

const LANDING_BANNER_VIDEO =
	"../assets/img/new_design/BackgroundImages/banner.mp4";

export function LoginBlock() {
	return (
		<div className="landing-page">
			<video
				className="video"
				src={LANDING_BANNER_VIDEO}
				loop
				muted
				playsInline
				autoPlay
			></video>

			<Box
				sx={{
					background:
						"linear-gradient(180deg, rgba(0,0,0,0) 10%, rgba(0,0,0,0.8) 50%)",
					width: "100%",
					height: "200px",
					zIndex: 1,
					bottom: "0px",
					position: "absolute",
				}}
			></Box>

			<div className="overlap-group">
				{SignupWidgetMain("registration")}
			</div>
		</div>
	);
}
